import { IconButtonProps, IconButton } from '@mui/material'
import { LinkProps as NextLinkProps } from 'next/link'
import { forwardRef } from 'react'
import { ComposableNextLink } from './InternalLinkButton'

interface InternalLinkIconButtonProps
  extends
    Omit<IconButtonProps<'a'>, 'href' | 'component' | 'onMouseEnter' | 'onTouchStart'>,
    Omit<NextLinkProps, 'passHref' | 'legacyBehavior'> {}

/**
 * Combines MUI's IconButton component (for styling) with Next.js Link for internal client-side navigation.
 */
export const InternalLinkIconButton = forwardRef<HTMLAnchorElement, InternalLinkIconButtonProps>(function InternalLinkIconButton(
  { href, ...props },
  ref
) {
  return <IconButton component={ComposableNextLink} {...props} to={href} ref={ref} />
})
